var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4c8b5d",
    fillRule: "evenodd",
    d: "M13 0c7.18 0 13 5.82 13 13s-5.82 12.999-13 12.999S0 20.179 0 13 5.82 0 13 0m-1.809 15.209-2.76-2.76c-.355-.342-1.098-.471-1.567.008-.465.477-.391 1.245-.037 1.585l3.576 3.584c.178.171.57.387.803.387s.575-.186.753-.357l7.273-7.268c.354-.341.432-1.131-.041-1.596-.48-.473-1.23-.349-1.585-.008z"
  })));
});
const SvgConfirmationFullIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfirmationFullIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDI2IDI2Ij4KICAgIDxwYXRoIGZpbGw9IiM0YzhiNWQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEzIDBjNy4xOCAwIDEzIDUuODIgMTMgMTNzLTUuODIgMTIuOTk5LTEzIDEyLjk5OVMwIDIwLjE3OSAwIDEzQzAgNS44MiA1LjgyIDAgMTMgMHptLTEuODA5IDE1LjIwOWwtMi43Ni0yLjc2Yy0uMzU1LS4zNDItMS4wOTgtLjQ3MS0xLjU2Ny4wMDgtLjQ2NS40NzctLjM5MSAxLjI0NS0uMDM3IDEuNTg1bDMuNTc2IDMuNTg0Yy4xNzguMTcxLjU3LjM4Ny44MDMuMzg3LjIzMyAwIC41NzUtLjE4Ni43NTMtLjM1N2w3LjI3My03LjI2OGMuMzU0LS4zNDEuNDMyLTEuMTMxLS4wNDEtMS41OTYtLjQ4LS40NzMtMS4yMy0uMzQ5LTEuNTg1LS4wMDhsLTYuNDE1IDYuNDI1eiIvPgo8L3N2Zz4K";